import React, { Component } from "react";
import { t } from "../../../components/CustomComponent.js";
import HomeMedia from "./HomeMedia.js";
import HomeLifestyle from "./HomeLifestyle.js";
import HomeCardContact from "./HomeCardContact.js";
import ICON from "../icons.js";

/* ============================================================================
 * HomeProjects — "โครงการใหม่ & โครงการเด่น" + กล่องไลฟ์สไตล์ด้านขวา
 *
 * แถวนี้แบ่งเป็น 2 คอลัมน์ : โครงการ 4 การ์ด (ซ้าย) และทางลัดตามไลฟ์สไตล์ (ขวา)
 * วางคู่กันเพราะเป็นการค้นหาคนละแบบของเรื่องเดียวกัน — เลือกจากโครงการที่รู้จัก
 * หรือเลือกจากเงื่อนไขการใช้ชีวิต ผู้ใช้จะได้ทางเลือกครบในสายตาเดียว
 *
 * เดิมเป็นแถบเลื่อนอัตโนมัติ เปลี่ยนเป็นกริดคงที่เพราะข้อความ "เริ่ม x ล้านบาท"
 * ต้องอ่านเทียบกันได้ ภาพที่เลื่อนตลอดเวลาทำให้เทียบราคายาก
 * ========================================================================== */
export default class HomeProjects extends Component {
  card = (item) => {
    const { onOpen } = this.props;

    return (
      <article key={item.id} className="hm-card hm-card--project" onClick={() => onOpen && onOpen(item)}>
        <div className="hm-card__media">
          <HomeMedia src={item.src} kind={item.kind} tone={item.tone} ratio={0.78} alt={item.name} />
          <div className="hm-card__badges">
            <span className={`hm-badge hm-badge--${item.badge_color}`}>{t(item.badge)}</span>
          </div>
        </div>

        <div className="hm-card__body">
          <h3 className="hm-card__title">{item.name}</h3>
          <div className="hm-card__price">
            <small>{t("home_price_start")}</small>
            {item.price}
            <span>{item.unit}</span>
          </div>
        </div>

        {/* ผู้ติดต่อของโครงการ — ใช้แถวเดียวกับการ์ดทรัพย์ ติดต่อได้จากหน้าแรกเลย */}
        <HomeCardContact contact={item.contact} />
      </article>
    );
  };

  render() {
    const { items = [], lifestyles, onViewAll, onLifestyle } = this.props;

    return (
      <section className="hm-section" id="hm-projects">
        <div className="hm-container">
          <div className="hm-split">
            <div className="hm-split__main">
              <div className="hm-section__head">
                <h2 className="hm-section__title">{t("home_projects_title")}</h2>
                {/* ยังไม่มีโครงการให้ดู = ไม่ต้องมีลิงก์ดูทั้งหมด ไม่งั้นกดไปเจอหน้าเปล่า */}
                {!!items.length && (
                  <button type="button" className="hm-section__link" onClick={onViewAll}>
                    {t("view_all")}
                    <span className="hm-ico">{ICON.chevron_right}</span>
                  </button>
                )}
              </div>

              {/* ยังไม่มีประกาศประเภท "โครงการใหม่" — บอกว่ากำลังอัปเดต ดีกว่าปล่อยพื้นที่โล่ง
                  ให้ดูเหมือนหน้าเว็บพัง (คอลัมน์ไลฟ์สไตล์ด้านขวายังอยู่ครบ) */}
              {items.length ? (
                <div className="hm-grid">{items.map(this.card)}</div>
              ) : (
                <div className="hm-soon">
                  <span className="hm-soon__icon hm-ico">{ICON.building}</span>
                  <div className="hm-soon__title">{t("home_projects_soon")}</div>
                  <div className="hm-soon__desc">{t("home_projects_soon_desc")}</div>
                </div>
              )}
            </div>

            <HomeLifestyle data={lifestyles} onSelect={onLifestyle} />
          </div>
        </div>
      </section>
    );
  }
}
